import { Dispatch } from 'redux';
import { GetInventoryFromPath, PostWithReturn } from '../../services/api/GenericClient';

type Action = {
  readonly type: string;
  readonly payload?: any;
};

export const setInventory =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(InventoryLoading());
      const path = '/dealsheet/inventory';
      const response = await GetInventoryFromPath(path);

      if (!response) {
        dispatch(InventoryLoaded([]));
      }

      if (response) {
        dispatch(InventoryLoaded(response));
      }
    } catch (err) {
      dispatch(InventoryError());
    }
  };

export const bulkChangeReplacement = async (payload, dealerId: string, isBulk: boolean) => {
  const initialPath = '/dashboard';
  const apiPath = initialPath.concat(
    `/bulkchangereplacementbackground?dealerId=${dealerId}&isBulk=${isBulk}`,
  );

  return await PostWithReturn(apiPath, payload);
};

export const InventoryLoading = (): Action => ({
  type: InventoryActionType.INVENTORY_LOADING as InventoryActionType.INVENTORY_LOADING,
});

export const InventoryLoaded = (payload): Action => ({
  type: InventoryActionType.INVENTORY_LOADED as InventoryActionType.INVENTORY_LOADED,
  payload: payload,
});

export const InventoryError = (): Action => ({
  type: InventoryActionType.INVENTORY_ERROR as InventoryActionType.INVENTORY_ERROR,
});

export const InventoryRemove = (): Action => ({
  type: InventoryActionType.INVENTORY_REMOVE as InventoryActionType.INVENTORY_REMOVE,
});

export const SetInventoryRemainingModal = (payload): Action => ({
  type: InventoryActionType.INVENTORY_REMAINING_MODAL as InventoryActionType.INVENTORY_REMAINING_MODAL,
  payload: payload,
});

export const SetInventoryRemainingModalData = (payload): Action => ({
  type: InventoryActionType.INVENTORY_REMAINING_MODAL_DATA as InventoryActionType.INVENTORY_REMAINING_MODAL_DATA,
  payload: payload,
});

export enum InventoryActionType {
  INVENTORY_LOADING = '[INVENTORY] Inventory Loading',
  INVENTORY_LOADED = '[INVENTORY] Inventory Loaded',
  INVENTORY_ERROR = '[INVENTORY] Inventory Error',
  INVENTORY_REMOVE = '[INVENTORY] Inventory Clear Redux',
  INVENTORY_REMAINING_MODAL = '[INVENTORY] Inventory Remaining Modal',
  INVENTORY_REMAINING_MODAL_DATA = '[INVENTORY] Inventory Remaining Modal Data',
}

export type InventoryActions = ReturnType<
  | typeof InventoryLoading
  | typeof InventoryLoaded
  | typeof InventoryError
  | typeof InventoryRemove
  | typeof SetInventoryRemainingModal
  | typeof SetInventoryRemainingModalData
>;
